export default {
  testimonials: {
    data: [],
    meta: {}
  },
  testimonial: {}
}
